export default function MultipleChoiceField({
  label,
  required,
  options,
  formData,
  index,
  onChange, 
}) {
  const currentField = formData?.[index] || {};
  const currentAnswer = currentField.answer;

  return (
    <div className="mb-6 gap-16">
      <label className="block text-sm font-medium mb-3 text-gray-900">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      {options.map((option, i) => {
        const isSelected =
          currentAnswer &&
          (typeof currentAnswer === "object"
            ? currentAnswer.index === option.index
            : currentAnswer === option.value);

        return (
          <div className="flex items-center gap-2 mb-4" key={option.index}>
            <input
              name={`field-${index}`}
              type="radio"
              value={option.value}
              checked={isSelected}
              onChange={() =>
                onChange(index, "answer", {
                  index: option.index,
                  value: option.value,
                })
              }
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
            />

            <label
              htmlFor={`field-${index}`}
              className="leading-none text-sm font-medium text-gray-900"
            >
              {option.value}
            </label>

            {/* Inline Note Input */}
            {formData[index].hasNotes && isSelected && (
              <input
                type="text"
                value={option.notes || ""}
                onChange={(e) =>
                  onChange(index, "notes", e.target.value, option.index)
                }
                placeholder="enter your notes here"
                className="ml-2 flex-1 px-3 py-2 bg-gray-50 rounded-lg border border-gray-300 text-sm text-gray-900"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
